import React from 'react';
import { STEP_IDS } from '../types/lectureForm.types';

// Import step components
import InformationStep from '../steps/InformationStep';
import GeneralConditionsStep from '../steps/GeneralConditionsStep';
import LectureTypeStep from '../steps/LectureTypeStep';
import ConditionsStep from '../steps/ConditionsStep';
import SpeakersStep from '../steps/SpeakersStep';
import LanguageStep from '../steps/LanguageStep';
import TitleStep from '../steps/TitleStep';
import DescriptionStep from '../steps/DescriptionStep';
import SubjectsStep from '../steps/SubjectsStep';
import TopicsStep from '../steps/TopicsStep';
import ImageStep from '../steps/ImageStep';
import HandoutStep from '../steps/HandoutStep';
import PresentationStep from '../steps/PresentationStep';
import ReviewStep from '../steps/ReviewStep';
import CommunicateStep from '../steps/CommunicateStep';
import BoothLocationStep from '../steps/BoothLocationStep';

// Step component mapping - using both STEP_IDS and string keys for flexibility
const STEP_COMPONENTS = {
  // Using STEP_IDS constants
  [STEP_IDS.INFORMATION]: InformationStep,
  [STEP_IDS.LECTURE_TYPE]: LectureTypeStep,
  [STEP_IDS.GENERAL_CONDITIONS]: GeneralConditionsStep,
  [STEP_IDS.TITLE]: TitleStep,
  [STEP_IDS.LANGUAGE]: LanguageStep,
  [STEP_IDS.TOPICS]: TopicsStep,
  [STEP_IDS.SPEAKERS]: SpeakersStep,
  [STEP_IDS.DESCRIPTION]: DescriptionStep,
  [STEP_IDS.SUBJECTS]: SubjectsStep,
  [STEP_IDS.IMAGE]: ImageStep,
  [STEP_IDS.HANDOUT]: HandoutStep,
  [STEP_IDS.PRESENTATION]: PresentationStep,
  [STEP_IDS.MARKETING]: CommunicateStep, // Rename communicate to marketing
  [STEP_IDS.REVIEW]: ReviewStep,

  // Direct string mappings for dynamic configs
  'information': InformationStep,
  'lecture_type': LectureTypeStep,
  'general_conditions': GeneralConditionsStep,
  'conditions': ConditionsStep,
  'title': TitleStep,
  'language': LanguageStep,
  'topics': TopicsStep,
  'speakers': SpeakersStep,
  'description': DescriptionStep,
  'subjects': SubjectsStep,
  'image': ImageStep,
  'booth_location': BoothLocationStep,
  'handout': HandoutStep,
  'presentation': PresentationStep,
  'marketing': CommunicateStep,
  'review': ReviewStep,

  // Component name mappings for config-based loading
  'InformationStep': InformationStep,
  'LectureTypeStep': LectureTypeStep,
  'GeneralConditionsStep': GeneralConditionsStep,
  'ConditionsStep': ConditionsStep,
  'TitleStep': TitleStep,
  'LanguageStep': LanguageStep,
  'TopicsStep': TopicsStep,
  'SpeakersStep': SpeakersStep,
  'DescriptionStep': DescriptionStep,
  'SubjectsStep': SubjectsStep,
  'ImageStep': ImageStep,
  'BoothLocationStep': BoothLocationStep,
  'HandoutStep': HandoutStep,
  'PresentationStep': PresentationStep,
  'CommunicateStep': CommunicateStep,
  'ReviewStep': ReviewStep
};

export default function StepRenderer({ activeStep, onStepComplete, onStepChange, companyId, eventId, lectureId, onSaveLecture, isSavingLecture }) {
  // Try to get the component using multiple strategies
  let StepComponent = STEP_COMPONENTS[activeStep];

  // If not found and activeStep is an object with a component property
  if (!StepComponent && activeStep?.component) {
    StepComponent = STEP_COMPONENTS[activeStep.component];
  }

  // Fallback if step component not found
  if (!StepComponent) {
    console.warn(`Step component not found for: ${activeStep}`, activeStep);
    return (
      <div className="text-center p-4">
        <h5>Schritt wird geladen...</h5>
        <p>Schritt "{activeStep}" ist noch nicht implementiert.</p>
      </div>
    );
  }

  return (
    <div className="step-content d-flex flex-column h-100">
      <StepComponent 
        onComplete={onStepComplete}
        onStepChange={onStepChange}
        stepId={activeStep}
        companyId={companyId}
        eventId={eventId}
        lectureId={lectureId}
        onSaveLecture={onSaveLecture}
        isSavingLecture={isSavingLecture}
      />
    </div>
  );
}